import { createAPIModule } from '@/api/utils';

export default createAPIModule({
  endpoint: 'panel',
});
